module.exports = __webpack_public_path__ + "static/img/detail1-2.5c2d79d9.png";